import React, { useState } from 'react';
import { Modal } from 'antd';
import COButton from '../COButton';
import styles from './EditModal.module.scss';
import { Formik, Form } from 'formik';
import { ReactComponent as DropLocation } from 'assets/icons/fill_location.svg';
import { Supplier } from 'models/Supplier/Supplier.model';
import {
  ButtonLabelsEditModal,
  ProcessingFacilityProps,
  ValueChainEditModalProps,
} from 'enums/ValueChainEditModalEnums';
import { ProcessingFacility } from 'models/ProcessingFacility/ProcessingFacility.model';
import CreateSupplierModal from '../CreateSupplierModal';
import BrandService from 'services/ProductsService/brand.service';
import { SupplierCreationUpdation } from 'services/ValueChainService/supplier.service';
interface CreateBrandModal {
  showModalState: boolean;
  handleModalCancel: () => void;
  handleModalConfirm: () => void;
  preFetchedData?: Supplier;
  preFetchedDataFacility?: ProcessingFacility;
  supplier?: boolean;
  processingFacility?: boolean;
  updateProcessingFacility?: () => void;
  updateSupplier?: (
    id: number | undefined,
    Supplier: SupplierCreationUpdation
  ) => Promise<void>;
  buttonLoading?: boolean;
}

const EditValueChainModal: React.FC<CreateBrandModal> = ({
  showModalState,
  handleModalCancel,
  handleModalConfirm,
  preFetchedData,
  preFetchedDataFacility,
  supplier,
  processingFacility,
  updateProcessingFacility,
  updateSupplier,
  buttonLoading,
}: CreateBrandModal) => {
  const { brand, loading } = BrandService();
  // const { fetchSuppliers, fetchProcessingFacilities } = ValueChainService();
  const [editFormModalState, setEditFormModalState] = useState<boolean>(false);
  const [supplierEditModalState, setSupplierEditModalState] =
    useState<boolean>(false);
  const preFetchedValue = {
    brandName: brand ? brand.name : ValueChainEditModalProps.EMPTY_STRING,
    category: brand ? brand.category : undefined,
  };

  const handleCancelModal = () => {
    setEditFormModalState(false);
  };
  const handleEditButton = () => {
    handleModalCancel();
    setEditFormModalState(true);
    localStorage.removeItem('scope1');
    localStorage.removeItem('scope2');
  };
  const handleOpenSupplierEditModal = () => {
    handleModalCancel();
    setSupplierEditModalState(true);
  };
  const handleSupplierEditModalCancel = () => {
    setSupplierEditModalState(false);
  };
  const handleSupplierEditModalConfirm = () => {
    setSupplierEditModalState(false);
  };
  const user = localStorage.getItem('userDetails');
  let parsedUser;
  if (user !== null) {
    parsedUser = JSON.parse(user);
  }

  return (
    <>
      <CreateSupplierModal
        showModalState={supplierEditModalState}
        handleModalCancel={handleSupplierEditModalCancel}
        handleModalConfirm={handleSupplierEditModalConfirm}
        preFetchedData={preFetchedData}
        updateSupplier={updateSupplier}
        id={parsedUser.id}
        loading={buttonLoading}
      />

      <Modal
        width={ValueChainEditModalProps.MODAL_WIDTH}
        footer={null}
        wrapClassName={styles.modalContainer}
        open={showModalState}
        onOk={handleModalConfirm}
        onCancel={handleModalCancel}>
        <div className={styles.formContainer}>
          <div className={styles.headerContainer}></div>

          {preFetchedData && loading ? (
            <h3>{ValueChainEditModalProps.LOADING_INDICATOR}</h3>
          ) : (
            <Formik
              enableReinitialize
              initialValues={preFetchedValue}
              onSubmit={values => {}}>
              <Form>
                <div className={styles.contentContainer}>
                  <div className={styles.fieldContainer}>
                    <h2>{supplier && preFetchedData?.name} </h2>
                    <h2>
                      {processingFacility && preFetchedDataFacility?.name}{' '}
                    </h2>
                  </div>
                  {supplier && (
                    <div className={styles.fieldContainer}>
                      <h3>
                        <DropLocation /> {preFetchedData?.address?.street}{' '}
                        {preFetchedData?.address?.province}{' '}
                        {preFetchedData?.address?.country}{' '}
                        {preFetchedData?.address?.postalCode}
                      </h3>
                    </div>
                  )}

                  {/* <DropLocation /> */}
                  {processingFacility && (
                    <>
                      <div className={styles.fieldContainer}>
                        <h3>
                          <DropLocation />{' '}
                          {preFetchedDataFacility?.address?.street}{' '}
                          {preFetchedDataFacility?.address?.province}{' '}
                          {preFetchedDataFacility?.address?.country}
                          {preFetchedDataFacility?.address?.postalCode}
                        </h3>
                      </div>
                      <div className={styles.processingFieldContainer}>
                        <div className={styles.scope1}>
                          <h4>{ProcessingFacilityProps.SCOPE_1}</h4>
                          {''}{' '}
                          <p>
                            {Number(preFetchedDataFacility?.scope1)?.toFixed(4)}
                          </p>
                        </div>
                        <div className={styles.scope2}>
                          <h4>{ProcessingFacilityProps.SCOPE_2}</h4>
                          {''}{' '}
                          <p>
                            {Number(preFetchedDataFacility?.scope2)?.toFixed(4)}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className={styles.buttonContainer}>
                  <div className={styles.singleButton}>
                    {supplier ? (
                      <COButton submit onClick={handleOpenSupplierEditModal}>
                        {ButtonLabelsEditModal.EDIT}
                      </COButton>
                    ) : (
                      <COButton submit onClick={handleEditButton}>
                        {ButtonLabelsEditModal.EDIT}
                      </COButton>
                    )}

                    <COButton secondary onClick={() => handleModalCancel()}>
                      {ButtonLabelsEditModal.CANCEL}
                    </COButton>
                  </div>
                </div>
              </Form>
            </Formik>
          )}
        </div>
      </Modal>
    </>
  );
};

export default EditValueChainModal;
